import { injectable, inject } from 'inversify-props';
import { IAuthService } from '@/services'
import axios from 'axios';

export interface IAxiosConfig {
  activate(): any;
}

@injectable()
export class AxiosConfig implements IAxiosConfig {
  @inject() private authService!: IAuthService;

  activate() {
    axios.interceptors.request.use(async (config) => {
      config.baseURL = '/';
      // set an access token whenever we have one
      const access_token = await this.authService.getAccessToken();
      if (access_token) {
        config.headers['Authorization'] = `Bearer ${access_token}`;
      }

      return config;
    }, this.requestError);
  }

  requestError(error) {
    return Promise.reject(error);
  }
}

export const axiosConfig = new AxiosConfig();
